"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendItem = (newItem) => (existingItems) => [...existingItems, newItem];
exports.truncateList = (maxLength) => (options) => maxLength ? options.slice(0, maxLength) : options;
exports.filterList = (filter) => {
    const searchRegExp = new RegExp(filter.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "ig");
    return (options) => options.filter(option => String(option.label).match(searchRegExp));
};
exports.prependItem = (filterItem) => (items) => [
    filterItem,
    ...items,
];
exports.isOptionSelected = (value) => (option) => {
    if (!Array.isArray(value)) {
        return value === option.value;
    }
    return value.includes(option.value);
};
exports.getNewValue = (value) => (newValue) => {
    if (Array.isArray(value)) {
        const newValueIndex = value.indexOf(newValue);
        if (newValueIndex === -1) {
            return [...value, newValue];
        }
        else {
            return [...value.slice(0, newValueIndex), ...value.slice(newValueIndex + 1)];
        }
    }
    return newValue;
};
exports.getDisplayValue = (internalValue) => (options) => {
    if (Array.isArray(internalValue)) {
        return options
            .filter(option => internalValue.includes(option.value))
            .map(option => option.label)
            .join(", ");
    }
    const valueExistsInOptions = options.find(option => option.value === internalValue);
    if (valueExistsInOptions) {
        return valueExistsInOptions.label || String(valueExistsInOptions.value);
    }
    if (internalValue === null) {
        return "";
    }
    return String(internalValue);
};
exports.optionsToContextMenuItems = (overrides) => (options) => options.map((option) => (Object.assign({}, option, { label: option.label || String(option.value) }, (overrides ? overrides(option) : {}))));
exports.getOptionFromItem = (haystack) => (needle) => {
    const result = haystack.find(item => needle.label === item.label);
    if (result) {
        return { label: result.label || result.value, value: result.value };
    }
    return undefined;
};
//# sourceMappingURL=Select.util.js.map